import { useTranslation } from 'react-i18next';

const renderUtils = {

    renderDryer: (dryer) => {
        return dryer ?
            renderDictionary(dryer.manufacturer) +
            dryer.model + " " +
            dryer.serialNumber
            : "";
    },

    renderEnumName: (enumValue, enumType, t) => {

        if (enumType === "enums/filter-kinds") {

            return enumValue === "LEVEL_1" ? "Filtr rodzaju 1 (suszarnia)" : "Filtr rodzaju 2 (port)";
        } else if (enumType === "enums/typeOfSeries") {

            return enumValue === "STANDARD" ? "Standardowa" : "Duża";
        } else if (enumType === "auditActionType") {
            const result = auditActionType(t)[enumValue];

            return result || enumValue;
        } else if (enumType === "enums/matrixOrSegment") {
            const result = matrixOrSegment(t)[enumValue];

            return result || enumValue;
        } else if (enumType === "enums/measurementType") {
            const result = measurementType(t)[enumValue];

            return result || enumValue;
        } else if (enumType === "enums/matrixInputType") {
            const result = matrixInputType(t)[enumValue];

            return result || enumValue;
        } else if (enumType === "enums/toolType") {
            const result = toolType(t)[enumValue];

            return result || enumValue;
        } else if (enumType === "toolTypesCreation") {
            const result = toolTypesCreation(t)[enumValue];

            return result || enumValue;
        } else if (enumType === "dictionaryType") {
            const result = dictionaryType[enumValue];

            return result || enumValue;

        } else if (enumType === "verificationStatus") {
            const result = verificationStatus(t)[enumValue];

            return result || enumValue;

        }
    }
};

const renderDictionary = (dictionary) => {
    return dictionary ? dictionary.name + " " : "";

};


const auditActionType = (t) => {
    return {
    "TOOL_VERIFICATION": t("administration.toolVerification"),
    "VERIFICATION_CREATION": t("administration.createVerification"),
    "VERIFICATION_COMPLETE": t("administration.verificationCompleted"),
    "VERIFICATION_CONFIGURATION_UPDATE": t("administration.completing"),
    "TOOL_SET_TEMPLATE_CREATION": t("administration.addition"),
    "TOOL_SET_TEMPLATE_REMOVAL": t("administration.removal"),
    };
};

const dictionaryType = {
    "MANUFACTURER": "Producent",
    "PRODUCT": "Product",
    "CLEANING_TOOL": "Czyszczenie",
    "SUPPLIER": "Dostawca"
};

const matrixOrSegment = (t) => {
    return {
        "MATRIX": t("administration.matrix"),
        "SEGMENT": "Segment"
    };
};


const verificationStatus = (t) => {
    return {
        "CONFIGURATION": t("verificationStatus.configuration"),
        "WAITING_FOR_VERIFICATION": t("verificationStatus.waiting"),
        "VERIFIED": t("verificationStatus.verified"),
    };
};

const measurementType= (t) => {
    return {
    "WORKING_LENGTH": t("administration.workingL"),
    "TOTAL_LENGTH": t("administration.totalL")
   };
};
const matrixInputType = (t) => {
    return {
    "ONE_SIDE": t("administration.oneSide"),
    "DOUBLE_SIDE": t("administration.doubleSided")
   };
};

const toolType= (t) => {
    return {
        "UPPER": t("administration.upper"),
        "LOWER": t("administration.lower"),
        "MATRIX": t("administration.matrix"),
        "SEGMENT": "Segment",
    };
};

const toolTypesCreation = (t) => {
    return {
    "UPPER": t("administration.upper"),
    "LOWER": t("administration.lower"),
    "MATRIX_SEGMENT": t("administration.matrixSegment")
    };
};
export default renderUtils;
